import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface ExceptionListOverviewProps {
  data: any
}

export default function ExceptionListOverview({ data }: ExceptionListOverviewProps) {
  const theme = useTheme()

  const bankExceptions =
    (data?.als_yhslqz_count || 0) + (data?.als_d90_yq_count || 0) + (data?.als_gt_d90_yq_count || 0)

  const onlineLendingExceptions =
    (data?.als_wlxdqzsl_count || 0) +
    (data?.als_dfxdqxsl_count || 0) +
    (data?.als_xfjrgsqzsl_count || 0) +
    (data?.als_rzzlgsqzsl_count || 0) +
    (data?.als_qcjrgsqzsl_count || 0) +
    (data?.als_qtjrgsqzsl_count || 0)

  const totalExceptions = bankExceptions + onlineLendingExceptions

  const countHitCategories = () => {
    const categories = [
      data?.als_yhslqz_count,
      data?.als_d90_yq_count,
      data?.als_gt_d90_yq_count,
      data?.als_wlxdqzsl_count,
      data?.als_dfxdqxsl_count,
      data?.als_xfjrgsqzsl_count,
      data?.als_rzzlgsqzsl_count,
      data?.als_qcjrgsqzsl_count,
      data?.als_qtjrgsqzsl_count,
    ]
    return categories.filter((count) => (count || 0) > 0).length
  }

  const hitCategories = countHitCategories()

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            异常名单概览
          </Text>
          <Text size="xs" className="text-gray-500">
            汇总银行与网贷机构的失联欺诈、逾期异常等负面信息,供风险审核参考。
          </Text>
        </div>
        <div className="grid gap-3 md:grid-cols-3">
          <SummaryItem label="银行异常总数" value={`${bankExceptions} 次`} subtitle="3类异常" />
          <SummaryItem label="网贷异常总数" value={`${onlineLendingExceptions} 次`} subtitle="6类机构" />
          <SummaryItem
            label="异常总计"
            value={`${totalExceptions} 次`}
            subtitle={totalExceptions > 0 ? `${hitCategories}类机构命中` : '无异常记录'}
          />
        </div>
      </Stack>
    </div>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  subtitle?: string
}

function SummaryItem({ label, value, subtitle }: SummaryItemProps) {
  const theme = useTheme()

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Text size="xs" className="text-gray-500">
        {label}
      </Text>
      <Text size="sm" fw={600} style={{ marginTop: '6px', color: theme.primaryColor }}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" className="text-gray-400" style={{ marginTop: '4px' }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}
